module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_hazel.15df32c0.png";